import { FETCH_PRODUCTS, ADD_TO_CART, REMOVE_FROM_CART, SEARCH_PRODUCTS, SHOW_SEARCH, CHANGE_CATEGORY, TOGGLE_FAVORITE, UPDATE_CART_ITEM } from './types';

import { API } from '../../config/api';
import { ITEMS_JSON_URL } from '../../config/domain';

export const updateCartItem = (id, patch) => ({ type: UPDATE_CART_ITEM, id, patch });

const LIKE_API  = API.likes;
const ITEMS_URL = ITEMS_JSON_URL;
const CACHE_KEY     = 'bv_products_cache';
const CACHE_VER_KEY = 'bv_products_ver';
const CACHE_TTL     = 0;

function lsGet(key) {
  try { return localStorage.getItem(key); } catch (e) { return null; }
}
function lsSet(key, val) {
  try { localStorage.setItem(key, val); } catch (e) {}
}
function lsRemove(key) {
  try { localStorage.removeItem(key); } catch (e) {}
}
function ssGet(key) {
  try { return sessionStorage.getItem(key); } catch (e) { return null; }
}

function getPassword() {
  return ssGet('userPassword') || lsGet('userPwd') || '';
}
export function savePassword(pwd) {
  try { sessionStorage.setItem('userPassword', pwd); } catch (e) {}
  lsSet('userPwd', pwd);
}

function parseProducts(data) {
  return data
    .filter(item => item.ID && item.Item && (item.Show || '').toUpperCase() === 'TRUE')
    .map((item, index) => ({
      id: String(item.ID),
      name: item.Item,
      price: 0,
      quantity: 1,
      weight: Number(item.Weight) || 0,
      organic: item.Organic === 'TRUE' || item.Organic === 'Yes' || item.organic === true,
      category: { id: index, name: item.Category },
      quantity_type: { id: 1, name: item.Size },
      image: [{ url: item.ImgURL ? item.ImgURL : 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22300%22 height=%22300%22%3E%3Crect width=%22300%22 height=%22300%22 fill=%22%23f5f0e8%22/%3E%3C/svg%3E' }]
    }));
}

function simpleHash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (((31 * h) + str.charCodeAt(i)) | 0);
  return h.toString(36);
}

export const getProducts = () => async (dispatch, getState, axios) => {
  try {
    const cached = lsGet(CACHE_KEY);
    const cachedVer = lsGet(CACHE_VER_KEY);
    if (cached) {
      const { products, ts } = (()=>{ try { return JSON.parse(cached); } catch { return {}; } })();
      if (products && products.length) {
        dispatch({ type: FETCH_PRODUCTS, payload: products });
        if (ts && Date.now() - ts < CACHE_TTL) return;
        try {
          const res = await axios.get(ITEMS_URL);
          const newVer = simpleHash(JSON.stringify(res.data));
          const freshProducts = parseProducts(res.data);
          if (newVer !== cachedVer) {
            dispatch({ type: FETCH_PRODUCTS, payload: freshProducts });
            lsSet(CACHE_VER_KEY, newVer);
          }
          lsSet(CACHE_KEY, JSON.stringify({ products: freshProducts, ts: Date.now() }));
        } catch (e) {}
        return;
      }
    }
  } catch (e) {}

  try {
    const res = await axios.get(ITEMS_URL + '?_=' + Date.now());
    const products = parseProducts(res.data);
    dispatch({ type: FETCH_PRODUCTS, payload: products });
    const ver = simpleHash(JSON.stringify(res.data));
    lsSet(CACHE_KEY, JSON.stringify({ products, ts: Date.now() }));
    lsSet(CACHE_VER_KEY, ver);
  } catch (err) {
    console.error('Failed loading products', err);
  }
};

export const fetchLikes = () => async (dispatch, getState, axios) => {
  const email    = lsGet('userEmail');
  const password = getPassword();
  if (!email) return;
  try {
    const res = await axios.post(LIKE_API, { action: 'get', email, password });
    if (res.data.success && res.data.liked) {
      const likedIds = res.data.liked.map(function(id) { return String(id); });
      dispatch({ type: TOGGLE_FAVORITE, payload: { likedIds } });
    }
  } catch (err) {
    console.error('Failed loading likes', err);
  }
};

export const toggleFavorite = (itemId) => async (dispatch, getState, axios) => {
  const email    = lsGet('userEmail');
  const password = getPassword();
  const id       = String(itemId);

  dispatch({ type: TOGGLE_FAVORITE, payload: { toggleId: id } });

  if (!email) return;

  try {
    const res = await axios.post(LIKE_API, { action: 'toggle', email, password, itemId: id });
    if (!res.data.success) throw new Error(res.data.message || 'Server error');
  } catch (err) {
    console.error('Failed to toggle like', err);
    dispatch({ type: TOGGLE_FAVORITE, payload: { toggleId: id } });
  }
};

export const bustItemsCache = () => {
  lsRemove('bv_products_cache');
  lsRemove('bv_products_ver');
};

export const addToCart = (product) => (dispatch) => dispatch({ type: ADD_TO_CART, product });
export const removeFromCart = (product) => (dispatch) => dispatch({ type: REMOVE_FROM_CART, product });
export const searchProduct = (term) => (dispatch) => dispatch({ type: SEARCH_PRODUCTS, term });
export const showSearch = (value) => (dispatch) => dispatch({ type: SHOW_SEARCH, value });
export const changeCategory = (value) => (dispatch) => dispatch({ type: CHANGE_CATEGORY, value });
